import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=3ee83e0b"
import script from "./CustomerGroups.vue?vue&type=script&lang=js"
export * from "./CustomerGroups.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroups.vue?vue&type=style&index=0&id=3ee83e0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports